<mat-tab-group *ngIf="survey && survey.Channel > -1" [selectedIndex]="selectedIndex" mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="40">
  <mat-tab label="Summary">
    <app-survey-summary [analysis]="this" [modelChecked]="modelChecked"></app-survey-summary>
  </mat-tab>
  <mat-tab *ngIf="showDataAnalysis()" label="Data">
    <app-basic-data [survey]="survey" [interview]="interview" [modelChecked]="modelChecked"></app-basic-data>
  </mat-tab>
  <mat-tab *ngIf="showMessageInsights()" label="Message Insights">
    <app-message-history [survey]="survey"></app-message-history>
  </mat-tab>
  <mat-tab *ngIf="showTrafficAnalysis()" label="Traffic Analysis">
    <div style="margin-bottom: 30px">
      <app-traffic-dashboard [surveyId]="survey.SurveyID"></app-traffic-dashboard>
    </div>
  </mat-tab>
  <!-->mat-tab *ngIf="showDataAnalysis() && questionTexts.length > 0" label="Text Analysis">
    <app-text-analysis [analysis]="this"></app-text-analysis>
  </mat-tab-->
  <mat-tab *ngIf="showDataAnalysis()" label="Reporting">
    <app-reports [survey]="survey" [interview]="interview" [modelChecked]="modelChecked"></app-reports>
  </mat-tab>
  <mat-tab *ngIf="canEdit" label="Import/Export">
    <app-automations [survey]="survey" [interview]="interview"></app-automations>
  </mat-tab>
</mat-tab-group>
